import SignUpForm$1, { Fields, Submit, Errors } from './SignUpForm.js';

// Components
const SignUpForm = Object.assign(SignUpForm$1, {
    Fields,
    Submit,
    Errors,
});

export { SignUpForm };
